import { render, staticRenderFns } from "./EpsCard.vue?vue&type=template&id=a81c0478&scoped=true"
import script from "./EpsCard.js?vue&type=script&lang=js&external"
export * from "./EpsCard.js?vue&type=script&lang=js&external"
import style0 from "./EpsCard.scss?vue&type=style&index=0&id=a81c0478&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81c0478",
  null
  
)

export default component.exports